module.exports = __webpack_public_path__ + "img/item_Story_17.62803d44.jpeg";